export default __webpack_public_path__ + "static/media/placeholder_store01-nl-web.5c585cd0.png";